import type {
  CommonResponseCollectionPaymentStudentProblemCountDto,
  CommonResponseMonthlyAcademyReceiptDto,
  CommonResponsePaymentMessageResponse,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'
import { mapSliceContent } from '~/schema/slice'

import {
  type AcademyPayment,
  AcademyPaymentSchema,
  type PaymentMessage,
  PaymentMessageSchema,
  type PaymentStudent,
  PaymentStudentSchema,
} from './schemas'

const ENTITY = 'Payment'

// 생성 타입과 실제 와이어가 어긋나는 필드:
//   추가 과금 조건 4종·activeStudentCount·billing 과 그 안의 nullable 필드(billingItemId·promotion*·prorate*·
//   quantity·pricing·studentCountRule·upTo·memo·subscription*·billingId·billingType·status·planTitle·planTier·
//   prepaid*·postpaid*·payMethod) — 생성 타입은 optional(키 생략)로 그리지만 서버는 키를 빼지 않고 null 을 싣는다
// 2026-10-14 백엔드 develop(6a0f8e7bb) 의 payment/model/dto/MonthlyAcademyReceiptDto.kt·BillingViewDto.kt 로 확인.
const asWireReceipt = (raw: CommonResponseMonthlyAcademyReceiptDto['data']): unknown => raw

export const adaptAcademyPayment = (
  raw: CommonResponseMonthlyAcademyReceiptDto['data'],
): AcademyPayment => parseApiResponse(AcademyPaymentSchema, asWireReceipt(raw), ENTITY)

export const adaptPaymentStudents = (
  raw: CommonResponseCollectionPaymentStudentProblemCountDto['data'],
): PaymentStudent[] => parseApiResponse(PaymentStudentSchema.array(), raw, ENTITY) ?? []

export const adaptPaymentMessage = (
  raw: CommonResponsePaymentMessageResponse['data'],
): PaymentMessage => {
  const message = parseApiResponse(PaymentMessageSchema, raw, ENTITY)
  return { ...message, messages: mapSliceContent(message.messages, (sms) => sms) }
}
